// this is an autogenerated file from App/Account/Content/Settings/Content/CommsEmail/Emails/Emails/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_CommsEmail_Emails_Emails_Content($comms_email_id: uuid!, $name: String!) {
  update_comms_outbound_emails_by_pk(
    pk_columns: { id: $comms_email_id }
    _set: { name: $name }
  ) {
    id
  }
}

`